import { render } from "./InfoBadge.vue?vue&type=template&id=8fe1be9e&scoped=true"
import script from "./InfoBadge.vue?vue&type=script&lang=js"
export * from "./InfoBadge.vue?vue&type=script&lang=js"

import "./InfoBadge.vue?vue&type=style&index=0&id=8fe1be9e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1815703633/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe1be9e"]])

export default __exports__